module.exports = __webpack_public_path__ + "static/media/stofferingen-28.3ab6dd58.jpg";